"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSectionConfig = void 0;
var defaultSectionConfig = {
    dark: false,
    titleConfig: {
        margin: {
            desktop: '0 0 40px',
            tablet: '0 0 40px',
            mobile: '0 0 30px'
        },
        defaultCss: {
            textAlign: 'center'
        }
    },
    subtitleConfig: {
        margin: {
            desktop: '0 0 40px',
            tablet: '0 0 40px',
            mobile: '0 0 30px'
        },
        defaultCss: {
            textAlign: 'center'
        }
    },
    descriptionConfig: {
        margin: {
            desktop: '0 0 40px',
            tablet: '0 0 40px',
            mobile: '0 0 30px'
        },
        defaultCss: {
            textAlign: 'center'
        }
    },
    padding: {
        desktop: '80px 0',
        tablet: '60px 0',
        mobile: '40px 0'
    },
    margin: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    },
    hrConfig: {
        margin: {
            desktop: '40px auto 60px',
            tablet: '40px auto 60px',
            mobile: '30px auto 50px'
        },
        defaultCss: {
            color: 'primary'
        }
    }
};
exports.defaultSectionConfig = defaultSectionConfig;
//# sourceMappingURL=Section.js.map